import { Controller } from "@hotwired/stimulus"

// A filter form without a "Filter" button (28.10.2026, Auftraggeber: "Nicht, dass ich erst nochmal auf Filtern
// drücken muss"): a select applies at once (data-action="change->autosubmit#submit"), a search field after a short
// pause in typing (data-action="input->autosubmit#later") or on Enter. The search keeps its focus and cursor after
// the page came back, so typing goes on.
export default class extends Controller {
  static values = { delay: { type: Number, default: 500 } }

  connect() {
    const field = this.element.querySelector("[data-autosubmit-focus]")
    if (field && sessionStorage.getItem("autosubmit-focus") === field.name) {
      sessionStorage.removeItem("autosubmit-focus")
      field.focus()
      const end = field.value.length
      field.setSelectionRange(end, end)
    }
  }

  submit() {
    clearTimeout(this.timer)
    this.element.requestSubmit()
  }

  later(event) {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      try { sessionStorage.setItem("autosubmit-focus", event.target.name) } catch (_) { /* private window */ }
      this.element.requestSubmit()
    }, this.delayValue)
  }

  disconnect() { clearTimeout(this.timer) }
}
